import api from "../../../config/gatewayConfig";
import { httpClient } from "../../httpClient";

// Provider reale per i click (MS_GestioneClick)
export const apiClickProvider = {
  storici: async (payload) => {
    // Nota: Authorization viene gestita dall'interceptor di `httpClient`.
    const response = await httpClient.post(api.storico, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response;
  },

  click: async (payload) => {
    const response = await httpClient.post(api.click, payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response;
  },
};

